import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  accountSetIsLoadingReducerType,
  accountSetEmailReducerType,
  accountSetUsernameReducerType,
  accountSetRestrictedWordsReducerType,
  accountSetPasswordDataReducerType,
} from './AccountConstants';

export const initialState = Map({
  username: '',
  email: '',
  isLoading: false,
  passwordData: {
    password: '',
    newPassword: '',
    confirmPassword: '',
  },
  restrictedWords: [],
});

const spec = {
  [accountSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [accountSetUsernameReducerType]: (state, action) => {
    const { username } = action.payload;
    return state.set('username', username);
  },
  [accountSetEmailReducerType]: (state, action) => {
    const { email } = action.payload;
    return state.set('email', email);
  },
  [accountSetPasswordDataReducerType]: (state, action) => {
    const currentData = state.get('passwordData');
    const { passwordData } = action.payload;
    return state.set('passwordData', { ...currentData, ...passwordData });
  },
  [accountSetRestrictedWordsReducerType]: (state, action) => state.set('restrictedWords', action.payload),
};

export default createReducerBySpec(spec, initialState);
